export type { IStatisticsProps } from './Statistics'
export { Statistics } from './Statistics'
